import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import { EffectFade, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

const Info2Carousel = ({ info1Data }) => {
  const swiperRef = useRef(null)
  const [currentInfoIndex, setCurrentInfoIndex] = useState(0)

  return (
    <Wrapper>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        effect="fade"
        className="bgImage"
        spaceBetween={0}
        slidesPerView={1}
        centeredSlides={true}
        onSlideChange={(_swiper) => setCurrentInfoIndex(_swiper.activeIndex)}
        fadeEffect={{ crossFade: true }}
        modules={[EffectFade]}
        speed={1000}
        style={{ height: "100%", width: "100%" }}
      >
        {info1Data?.block.map((content, index) => (
          <SwiperSlide
            key={content?.img?.publicURL + index?.toString()}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              style={{
                width: "40%",
                height: "100%",
                marginLeft: "auto",
                objectFit: "cover",
              }}
              alt={content?.content?.filename}
              src={content?.img?.publicURL}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="copy">
        <div className="mainText">
          <div className="headline">
            {info1Data?.block[currentInfoIndex]?.headline &&
              (() => {
                const [firstWord, ...rest] =
                  info1Data.block[currentInfoIndex].headline.split(" ")
                return (
                  <>
                    {currentInfoIndex != 0 ? (
                      <span>
                        {firstWord} <br />
                      </span>
                    ) : (
                      <img
                        src="/assets/imgs/berkeley.png"
                        style={{ width: "50%", filter: "invert(75%)" }}
                        alt=""
                      />
                    )}
                    <span
                      style={{
                        fontStyle: "italic",
                        textTransform: "lowercase",
                        color: "var(--accent)",
                      }}
                    >
                      {rest.join(" ")}
                    </span>
                  </>
                )
              })()}
          </div>
          <div className="body">{info1Data?.block[currentInfoIndex]?.body}</div>
        </div>
      </div>
      <div className="bottomBar">
        <div className="controls">
          <div className="button">
            <div
              onClick={() => {
                if (currentInfoIndex - 1 !== -1) {
                  setCurrentInfoIndex(currentInfoIndex - 1)
                  swiperRef.current.slideTo(currentInfoIndex - 1)
                } else {
                  setCurrentInfoIndex(info1Data?.block?.length - 1)
                  swiperRef.current.slideTo(info1Data?.block.length - 1)
                }
              }}
            >
              {" "}
              <img src="/assets/icons/back.svg" alt="" />
            </div>
            <div
              onClick={() => {
                if (currentInfoIndex + 1 !== info1Data?.block?.length) {
                  setCurrentInfoIndex(currentInfoIndex + 1)
                  swiperRef.current.slideTo(currentInfoIndex + 1)
                } else {
                  setCurrentInfoIndex(0)
                  swiperRef.current.slideTo(0)
                }
              }}
            >
              <img
                src="/assets/icons/back.svg"
                style={{ transform: "rotate(180deg)" }}
                alt=""
              />
            </div>
          </div>
          <div className="timeline">
            {info1Data?.block?.map((headline, index) => (
              <div
                key={headline.headline}
                onClick={() => {
                  setCurrentInfoIndex(index), swiperRef.current.slideTo(index)
                }}
                className={index === currentInfoIndex ? "active" : ""}
              >
                {headline.headline}
              </div>
            ))}
          </div>
        </div>
        <div className="index">
          {currentInfoIndex + 1}/{info1Data?.block?.length}
        </div>
      </div>
    </Wrapper>
  )
}

export default Info2Carousel

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-image: url("/assets/imgs/bg2.jpg");
  background-size: cover;

  .bgImage {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .copy {
    width: 90%;
    margin-left: auto;
    height: 85%;
    border-left: 1px solid var(--accent);
    padding: 2.75rem;
    display: flex;
    align-items: center;
    color: white;
    z-index: 1;
    pointer-events: none;

    .mainText {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .headline {
        font-size: 4rem;
        color: var(--secondary);
        opacity: 0.75;
      }

      .body {
        width: 90%;
        font-size: 1.25rem;
        line-height: 150%;
        color: var(--secondary);
      }
    }
  }

  .bottomBar {
    display: flex;
    width: 60%;
    height: 15%;
    /* box-shadow: inset 0 -200px 100px 10px rgba(0, 0, 0, 0.25); */
    border-top: 1px solid var(--accent);
    z-index: 1;
    padding: 0 4rem;
  }

  .controls {
    width: 60%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5rem;
    z-index: 1;

    .button {
      position: fixed;
      left: 0;
      margin: 5rem;
      display: flex;
      gap: 1rem;
      cursor: pointer;

      div {
        border:1px solid white;
        background-color: var(--secondary);
        padding: 1rem;
        color: var(--secondary);
        width: 4rem;
        height: 4rem;
        border-radius: 5px;
        img {
          width: 100%;
          height: 100%;
          padding: 0.5rem;
          filter: invert(100%);
        }
        &:active {
          opacity: 0.75;
          transform: scale(0.95);
          transition: 0.3s;
        }
      }
    }

    .timeline {
      display: flex;
      color: #00000051;
      gap: 2rem;
      transition: 0.3s;
      cursor: pointer;
      margin: auto;

      .active {
        color: var(--secondary);
        transition: 0.3s;
      }
    }
  }

  .index {
    margin: auto 0;
    margin-left: auto;
    font-size: 2rem;
    color: var(--secondary);
    letter-spacing: 5px;
  }
`
